import React, { useEffect, useState } from "react"
import ClientReportCard from "../../components/ClientReportCard.molecule"
import {
  ValueWithLabelContainer,
  ValueWithLabelTemplate,
} from "../../../../components/layouts/containers/ValueWithLabelElements.container"
import { numberFormatter } from "../../../../utils/numbers.utils"
import { getClientReportTimeConsumption } from "../../../../services/clientReport.service"

const ClientReportSprintTimeConsumption = ({
  sprintData,
  refresh,
  hideAverages,
}) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState({ ...sprintData })

  useEffect(() => {
    fetchClientSprintTimeConsumption()
  }, [sprintData, refresh])

  const fetchClientSprintTimeConsumption = async () => {
    setLoading(true)
    try {
      if (!sprintData?.id) {
        return
      }
      const response = await getClientReportTimeConsumption(sprintData.id)
      if (!response.success) {
        throw new Error(response.message)
      }
      const result = response.result || {}
      setData({
        ...sprintData,
        ...result,
      })
    } catch (error) {
      console.error("Error fetching sprint summary:", error)
    } finally {
      setLoading(false)
    }
  }
  const customAverageConsumptionFormat = (time, suffix) => {
    return time > 0 ?
        <span className="flex align-items-center gap-1">
          <span className="flex align-items-baseline gap-1">
            <span>{numberFormatter(time, 1)}</span>
            <p className="text-base">{suffix}</p>
          </span>
        </span>
      : <span className="flex align-items-center gap-1">
          - <p className="text-xl m-0">{suffix}</p>
        </span>
  }
  return (
    <ClientReportCard
      title={"Consumo de horas"}
      iconClassName="pi pi-clock text-3xl"
      className="flex-1 font-cairo flex-shrink-0"
    >
      <ValueWithLabelContainer>
        <ValueWithLabelTemplate
          label="Consumo del sprint"
          value={customAverageConsumptionFormat(
            data?.consumedHoursInPeriod,
            "horas"
          )}
          labelTooltip
          labelTooltipIcon={"pi pi-info-circle"}
          labelTooltipPosition="top"
          labelTooltipContent="Horas facturadas durante el periodo del sprint"
          loading={loading}
        />
        <ValueWithLabelTemplate
          label="Consumo total al corte"
          value={customAverageConsumptionFormat(
            data?.totalConsumedHours,
            "horas"
          )}
          labelTooltip
          labelTooltipIcon={"pi pi-info-circle"}
          labelTooltipPosition="top"
          labelTooltipContent="Horas totales facturadas hasta la fecha final este sprint"
          loading={loading}
        />
        {!hideAverages && (
          <ValueWithLabelTemplate
            label="Promedio semanal"
            value={customAverageConsumptionFormat(
              data?.lastEightWeeksTruncatedAverage,
              "hs/sem"
            )}
            loading={loading}
          />
        )}

        {!hideAverages && (
          <ValueWithLabelTemplate
            label="Promedio mensual"
            value={customAverageConsumptionFormat(
              data?.historicalMonthlyAverage,
              "hs/mes"
            )}
            loading={loading}
          />
        )}
      </ValueWithLabelContainer>
    </ClientReportCard>
  )
}

export default ClientReportSprintTimeConsumption
